export enum EnumOrigemPedido {
  Loja = 'loja',
  Admin = 'admin',
  Multiloja = 'multiloja',
  Bot = 'bot',
  Garcom = 'garcom',
  Balcao = 'balcao',
  Ifood = 'ifood',
  Keeta = 'keeta',
  Food99 = '99food',
  OpenDelivery = 'openapi',
  Totem = 'totem',
  Api = 'api',
  CentralPedidos = 'CENTRAL_PEDIDOS',
  ReposicaoInterna = 'REPOSICAO_INTERNA',
}
